import { render, staticRenderFns } from "./InsuredFormInfo.vue?vue&type=template&id=1dae419a&scoped=true&"
import script from "./InsuredFormInfo.vue?vue&type=script&lang=ts&"
export * from "./InsuredFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InsuredFormInfo.vue?vue&type=style&index=0&id=1dae419a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae419a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
